import PropTypes from 'prop-types'
import React from 'react'

import Icon from 'components/Icon'
import ShuffleSquares from 'components/ShuffleSquares'
import { RU, JP } from 'constants/countries'
import { LocalizationContext } from 'contexts/Localization'
import { Row, Col } from 'styles/components/layout'
import { H2, Text } from 'styles/components/typography'

import {
  SectionWrapperStyled,
  SquaresBoxMd,
  SquaresBox,
  IconWrapper,
  ArticleStyled,
  ImgIso,
} from './styles'

/**
 * KitScience - component to show common for kits block with
 * science description behind a test kit
 *
 * @param {object} props - properties of component
 * @returns {node} KitScience
 */
const KitScience = props => {
  const { data, mobile, tablet, bgColor, squareBg } = props
  const {
    locale,
    paths: { cdn_global },
  } = React.useContext(LocalizationContext)

  return (
    <SectionWrapperStyled
      bgColor={bgColor}
      className="text-white"
      beforeElement={
        mobile || tablet ? null : (
          <SquaresBoxMd>
            <ShuffleSquares theme={squareBg} />
          </SquaresBoxMd>
        )
      }
    >
      <Row>
        <Col width={{ xs: 1, lg: 1 / 2 }}>
          <ArticleStyled>
            <H2 dangerouslySetInnerHTML={{ __html: data.title }} />
            <Text dangerouslySetInnerHTML={{ __html: data.content }} />
            {locale !== RU && (
              <>
                <IconWrapper width={60} height={60}>
                  <ImgIso
                    image={`${cdn_global}/iso/iso`}
                    imageType="png"
                    imageSizes={{
                      xs: 120,
                      md: 120,
                      lg: 120,
                    }}
                    alt="iso"
                    quality={{
                      mobile2x: 100,
                      mobile3x: 100,
                      tablet2x: 100,
                      tablet3x: 100,
                      retina: 100,
                      uhd: 100,
                    }}
                  />
                </IconWrapper>
                <IconWrapper width={49} height={35}>
                  <Icon id="ce" />
                </IconWrapper>
                {locale !== JP && (
                  <IconWrapper width={65} height={35}>
                    <Icon id="ivd" />
                  </IconWrapper>
                )}
              </>
            )}
          </ArticleStyled>
        </Col>
      </Row>

      {mobile || tablet ? (
        <SquaresBox>
          <ShuffleSquares theme={squareBg} />
        </SquaresBox>
      ) : null}
    </SectionWrapperStyled>
  )
}

KitScience.propTypes = {
  /**  Data to show */
  data: PropTypes.shape({
    content: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,

  /**  Flag is it mobile */
  mobile: PropTypes.bool.isRequired,

  /**  Flag is it tablet */
  tablet: PropTypes.bool.isRequired,

  /** Background color of container */
  bgColor: PropTypes.string,

  /** Background color of shuffle squares container */
  squareBg: PropTypes.string,
}

KitScience.defaultProps = {
  bgColor: '',
  squareBg: 'purple',
}

export default KitScience
